<div class="row justify-content-center allergy-card">
    <!-- <div class="col-6 col-sm-5 col-md-3" *ngIf="pastSHX.length == 0">
        <div class="bg-info h-100 card mb-3 p-3 text-center text-white" (click)="modalPastSurgHX()">
            <span class="icon mb-3">
                <img height="25" src="../../../assets/images/Icons/plus.svg">
            </span>
            <h6 class="font-weight-normal mb-0">Add Past Surgical History</h6>
        </div>
    </div> -->
    <div class="col-6 col-sm-5 col-md-3" *ngIf="pastSHX.length == 0">
        <div class="bg-info card h-100 mb-3 p-3 text-center text-white" (click)="modalPastSurgHX()">
            <span class="icon mb-3 bg-white">
                <img height="23" src="../../../assets/images/Icons/plus.svg">
            </span>
            <h6 class="font-weight-normal mb-0">{{'past_surgical_history.add_past_surgical_history'|translate}}</h6>
        </div>
    </div>
    <div class="col-6 col-sm-5 col-md-3" *ngIf="pastSHX.length == 0">
        <div class="card mb-3 h-100 p-3 text-center text-info" (click)="setNoKnownPastSurgHX()">
            <span class="icon mb-3">
                <img height="23" src="../../../assets/images/Icons/cross.svg">
            </span>
            <h6 class="font-weight-normal mb-0">{{'past_surgical_history.no_known_past_surgical_history'|translate}}</h6>
        </div>
    </div>

    <!--<div class="col-12 " *ngIf="pastSHX.length > 0">
      <button class="btn btn-primary btncare" style="float: right;" type="button" (click)="modalPastSurgHX()">{{'button.add_PSH'|translate}}</button>
    </div>-->

</div>
<!-- <ng-container *ngIf="!isLoadingPE"> -->
<ng-container *ngIf="pastSHX.length >0 else notFoundPA">
    <div class="container flex-grow-1 overflow-auto">
        <div class="specialist-list ">
          <div class="form-row">
            <div class="col-12 mb-4 mt-2" *ngIf="pastSHX.length > 0">
              <button class="btn btn-primary btncare" style="float: right;" type="button" (click)="modalPastSurgHX()">{{'button.add_PSH'|translate}}</button>
            </div>
            <div class="col-lg-6" *ngFor="let pastSG of pastSHX">
              <div class="card  mb-4 pb-3">
                <div class="card-body p-0">
                  <div class="align-items-center d-flex justify-content-between mb-2">
                    <h6 class="font-weight-bold mb-0">
                      <span>{{'past_surgical_history.surgical_procedure_label'|translate}} </span>
                    </h6>

                    <div class="ctabtns">
                      <!--<a (click)="editPastSurg(pastSG)" class="mr-3"><i title="{{'link.edit'|translate}}"
            class="fas fa-edit text-dark"></i></a>-->
                      <a href="javascript:void(0)" (click)="deletePastSurgery(pastSG)" class="text-dark">
                        {{'link.delete'|translate}}
                        <!--<i title="{{'link.delete'|translate}}"class="far fa-trash-alt text-danger"></i>-->
                      </a>
                    </div>
                  </div>

                  <div class="mb-2">
                    <span class="text-muted font-weight-bold mr-1">{{ (pastSG.surgerY_NAME |titlecase)|| 'N/A'}}</span>

                  </div>
                  <div class="mb-2"
                       [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalDate ? '' : 'none'}">
                    <span>{{'past_surgical_history.date_label'|translate}}: </span>
                    <span *ngIf="pastSG.surgerY_DATE != '' && pastSG.surgerY_DATE != 'null'" class="text-muted font-weight-bold mr-1">{{pastSG.surgerY_DATE | date:'MM/dd/yyyy'}}</span>
                    <span *ngIf="pastSG.surgerY_DATE == '' || pastSG.surgerY_DATE == 'null'" class="text-muted font-weight-bold mr-1"></span>
                  </div>
                  <!--<div class="mb-2"
            [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalPlace ? '' : 'none'}">
          <span class="text-muted font-weight-bold mr-1">{{'past_surgical_history.place'|translate}}:</span>
            <span>{{pastSG.surgerY_PLACE || 'N/A'}}</span>
        </div>-->
                  <!--<div [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalComplications ? '' : 'none'}">
          <span class="text-muted font-weight-bold mr-1">{{'past_surgical_history.post_op_complications_label'|translate}}:</span>
            <span>{{pastSG.posT_SURGERY_COMPLICATIONS || 'N/A'}}</span>
        </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</ng-container>
<ng-template #notFoundPA>
    <div class="col-12 mt-4 text-center px-0">
      <p class="mb-0 text-danger">{{'past_surgical_history.no_surgical_history'|translate}}.</p>
    </div>
</ng-template>
<!-- </ng-container> -->

<!-- delete  -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="delPastSurg">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body p-4 text-center">
                <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'past_surgical_history.are_you_sure_you_want_to_delete_surgical_history'|translate}}</strong></h5>
                <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                        id="closeDeleteAllergyModel">
                  {{'button.cancel'|translate}}
                </button>
                <button type="button" id="closeDeleteFamilyHistory" (click)="DeleteSurgicalHX()"
                        class="btn btn-primary rbtn">
                  {{'button.delete'|translate}}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- New past surgical history Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="newPastSurg">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{'past_surgical_history.add_past_surgical_history'|translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="form-row">

                <div class="col-md-12">
                  <div class="form-group">
                    <div class="mb-2 border-bottom fw-bold">
                      <label class="form-label fw-bold">{{'past_surgical_history.surgical_procedure_label'|translate}}<span class="text-danger">*</span></label>
                      <input type="text" class="form-control border-0" placeholder="{{'past_surgical_history.surgical_procedure_Placeholder'|translate}}"
                             [(ngModel)]="savepastHHX.surgeryName" (input)="inputSurgeryName($event,'add')" id="psp">
                    </div>
                    <div class="mb-2">
                      <span *ngIf="isSurgeryNameNull" class="err">
                        {{'past_surgical_history.please_enter_surgical_procedure'|translate}}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12" [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalDate ? '' : 'none'}">
                  <div class="form-group border-bottom">
                    <label class="form-label fw-bold">{{'past_surgical_history.date_label'|translate}}</label>
                    <input class="form-control add-on border-0" (focusout)="focusOutFunction($event, 0)" (change)="onChangeDate($event)" tabindex="17" type="date"
                           min="{{'1901-01-01' | date:'yyyy-MM-dd'}}" max="{{curDate | date:'yyyy-MM-dd'}}" [(ngModel)]="savepastHHX.surgeryDate">
                  </div>
                  <p *ngIf="isDateError" class="err">{{'past_surgical_history.selected_date_should_be_prior_to_current_date'|translate}}.</p>
                </div>
                <!--<div class="col-md-12" [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalPlace ? '' : 'none'}">
    <div class="form-group form-floating">
      <input type="text" class="form-control" placeholder="{{'past_surgical_history.place_of_surgery_label'|translate}}"
             [(ngModel)]="savepastHHX.surgeryPlace">
      <label>{{'past_surgical_history.place_of_surgery_label'|translate}}</label>
    </div>
  </div>-->
                <!--<div class="col-md-12"
       [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalComplications ? '' : 'none'}">
    <div class="form-group form-floating">
      <input type="text" class="form-control" placeholder="{{'past_surgical_history.post_op_complications_label'|translate}}"
             [(ngModel)]="savepastHHX.postSurgeryComplications">
      <label>
        {{'past_surgical_history.post_op_complications_label'|translate}}</label>
    </div>
  </div>-->
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">{{'button.close'|translate}}</button>
              <button type="button" type="button" (click)="savePastSurgicalHX()" class="btn btn-primary ">{{'button.save'|translate}}</button>
            </div>
        </div>
    </div>
</div>
<!-- edit past surgical history Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="editPastSurg">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{'past_surgical_history.update_past_surgical_history'|translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-row">
                    <div class="col-md-12" [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalDate ? '' : 'none'}">
                        <div class="form-group form-floating">
                            <input class="form-control add-on" (change)="onChangeDate($event)" tabindex="17" type="date"
                            (focusout)="focusOutFunction($event, 1)" min="{{'1901-01-01' | date:'yyyy-MM-dd'
                      }}"
                      max="{{curDate | date:'yyyy-MM-dd'}}" [(ngModel)]="updatePastSurg.surgerY_DATE">
                            <label>{{'past_surgical_history.date_label'|translate}}</label>
                            <p *ngIf="isDateError" class="err">{{'past_surgical_history.selected_date_should_be_prior_to_current_date'|translate}}</p>
</div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group form-floating">
                            <input type="text" class="form-control" placeholder="{{'past_surgical_history.surgical_procedure_label'|translate}}"
                                [(ngModel)]="updatePastSurg.surgerY_NAME" (input)="inputSurgeryName($event,'update')">
                            <label>{{'past_surgical_history.surgical_procedure_label'|translate}}<span class="text-danger">*</span></label>
                            <p *ngIf="isUpdateSurgicalNameNull" class="err">{{'past_surgical_history.please_enter_surgical_procedure'|translate}}</p>
                        </div>
                    </div>
                    <!--<div class="col-md-12" [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalPlace ? '' : 'none'}">
                        <div class="form-group form-floating">
                            <input type="text" class="form-control" placeholder="{{'past_surgical_history.place_of_surgery_label'|translate}}"
                                [(ngModel)]="updatePastSurg.surgerY_PLACE">
                            <label>{{'past_surgical_history.place_of_surgery_label'|translate}}</label>
                        </div>
                    </div>-->
                    <!--<div class="col-md-12"
                        [ngStyle]="{'display' : intakeFieldsSetting.isSurgicalComplications ? '' : 'none'}">
                        <div class="form-group form-floating">
                            <input type="text" class="form-control" placeholder="{{'past_surgical_history.post_op_complications_label'|translate}}"
                                [(ngModel)]="updatePastSurg.posT_SURGERY_COMPLICATIONS">
                            <label>{{'past_surgical_history.post_op_complications_label'|translate}}</label>
                        </div>
                    </div>-->
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">{{'button.close'|translate}}</button>
              <button type="button" type="button" (click)="updatePastSurgHX()"
                      class="btn btn-primary ">
                {{'button.update'|translate}}
              </button>
            </div>
        </div>
    </div>
</div>
